var _isMobile = undefined;
export var isMobileDevice = function isMobileDevice() {
  var includeTablet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (_isMobile === undefined) {
    _isMobile = isAndroid(includeTablet) || isIOS(includeTablet);
  }

  return _isMobile;
};
export var isAndroid = function isAndroid() {
  var _navigator, _navigator2, _navigator2$userAgent, _navigator2$userAgent2;

  var includeTablet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return /Android/i.test((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent) && (includeTablet || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : (_navigator2$userAgent = _navigator2.userAgent) === null || _navigator2$userAgent === void 0 ? void 0 : (_navigator2$userAgent2 = _navigator2$userAgent.toLowerCase()) === null || _navigator2$userAgent2 === void 0 ? void 0 : _navigator2$userAgent2.indexOf('mobile')) >= 0);
};
export var isIOS = function isIOS() {
  var _navigator3, _navigator4;

  var includeTablet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return /iPhone|iPod/i.test((_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.userAgent) || includeTablet && /iPad/i.test((_navigator4 = navigator) === null || _navigator4 === void 0 ? void 0 : _navigator4.userAgent);
};
export var isInternetExplorerBrowser = function isInternetExplorerBrowser() {
  return /(MSIE (9|10))|(rv:11.0)/i.test(navigator.userAgent);
};
export var isLegacyEdgeBrowser = function isLegacyEdgeBrowser() {
  return /Edge\/\d./i.test(navigator.userAgent);
};
export var isChromiumBasedEdgeBrowser = function isChromiumBasedEdgeBrowser() {
  return /Edg\/\d./i.test(navigator.userAgent);
};
export var isFirefox = function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};
export var isSafari = function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};